export default __webpack_public_path__ + "static/media/icon-invcenter.6e4c061f.svg";